export default __webpack_public_path__ + "static/media/BangladeshFisheriesDevelopmentCorporation(BFDC).aa7f5787.jpg";